import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { of } from 'rxjs'
import { catchError, concatMap, map, tap, withLatestFrom } from 'rxjs/operators'
import { SettingsService } from '../../modules/settings'
import { SettingActions, SettingSelectors } from './setting-index'
import { SettingState } from './setting.state'

@Injectable()
export class SettingEffects {
  constructor(
    private settingsService: SettingsService,
    private actions$: Actions,
    private store: Store<SettingState>
  ) {}

  getSetting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SettingActions.settingRequested),
      concatMap((action) =>
        of(action).pipe(
          withLatestFrom(this.store.select(SettingSelectors.selectSettings)),
          concatMap(([action, settings]) => {
            const name = action.name
            const setting = settings.find((setting) => setting.name === action.name)
            if (setting) {
              return of(SettingActions.settingRetrieved({ name, setting }))
            }

            return this.settingsService.getSettingUncached(action.name).pipe(
              map((setting) => {
                return SettingActions.settingRetrieved({ name, setting })
              }),
              catchError(() => of(SettingActions.settingRequestFailed({ name })))
            )
          })
        )
      )
    )
  )
}
